import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
import * as page from "./page.js";
$ = jQuery;

export function init(){

    loadAnimation();

    gsap.fromTo($(".initial-hide"), 
        {
            opacity:0
        },
        {
            opacity:1,
            delay:4,
            duration:1,
            ease:Power3.easeOut,
            onComplete:function(){
                $(this).removeClass("initial-hide");
            }
        }
    );
  


    function loadAnimation(){
        var loader = $(".loader");
        var loaderCenterBox = $(".loader .center-box");
        var loaderLogo = $(".loader .logo");
        var loaderLogoSvg = $(".loader .logo svg");

        gsap.fromTo($(loaderLogo),
            {
                opacity:0
            },
            {
                opacity:1,
                scale:1,
                delay:0.5,
                duration:1,
                ease:Power3.easeOut,
            }
        );
        gsap.to($(loaderCenterBox),
            {
                top:"0%",
                left:"0%",
                marginLeft:"6px",
                marginTop:"6px",
                delay:3,
                duration:1,
                ease:Power3.easeInOut,
            }
        );
        gsap.to($(loaderLogoSvg),
            {
                rotate:"1456deg",
                delay:0.5,
                duration:2.5,
                ease:Power3.easeOut,
                
            }
        );
        
    }
}
